export const environment = {
  baseUrl: 'http://localhost:4200',
  nextApiBaseUrl: 'https://api-uat.newnext.krungthai.com',
  dglApiBaseUrl: 'https://apigw-dgl-lfm-uat.th-service.co.in',
  production: false,
  mode: 'uat',
  version: 'uat4.6.81',
  tagId: true,
  noCache: true,
  gtmId: 'GTM-K3GLLFPP',
  urlExternalWebsite: 'ktbnextstg://next.co.th/miniapp/webpartner?miniAppUUID=:miniAppUUID&miniAppDestination=:miniAppDestination&miniAppParams=:miniAppParams',
  miniAppUUID: '599e9968-97cc-44d9-9152-1e8eecc9111a',
  urlNextDeeplink: 'ktbnextstg://next.co.th',
};
